import {
  AUTH_IDENTIFY_ERROR,
  AUTH_IDENTIFY_REQUEST,
  AUTH_IDENTIFY_SUCCESS,
} from '../types'
import auth from '~gatsby-theme-autonomy/services/auth'

export const identifyRequest = () => {
  return {
    type: AUTH_IDENTIFY_REQUEST,
  }
}

/**
 * Action creator for AUTH_IDENTIFY_SUCCESS. It accepts either a string token OR
 * null, if the user is just not logged in.
 */
export const identifySuccess = (token) => {
  return {
    type: AUTH_IDENTIFY_SUCCESS,
    payload: {
      token,
    },
  }
}

export const identifyError = (error, meta = {}) => {
  return {
    type: AUTH_IDENTIFY_ERROR,
    error: true,
    meta,
    payload: {
      error,
    },
  }
}

export const handleCallback = () => async (dispatch) => {
  try {
    dispatch(identifyRequest())
    const token = await auth.handleCallback()
    dispatch(identifySuccess(token))
  } catch (error) {
    dispatch(identifyError(error))
    throw error
  }
}

export const getToken = () => async (dispatch, _getState) => {
  try {
    dispatch(identifyRequest())
    const token = await auth.getToken()
    dispatch(identifySuccess(token))
  } catch (error) {
    dispatch(identifyError(error))
    throw error
  }
}
